module.exports = __webpack_public_path__ + "assets/img/0222.53388fdf.png";